import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "navbar is-transparent" }
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = { class: "navbar-item" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon-text has-text-success" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home fa-border" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "navbar-burger",
  "data-target": "navbarExampleTransparentExample"
}, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_8 = {
  id: "navbarExampleTransparentExample",
  class: "navbar-menu"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-start" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "navbar-end"
}
const _hoisted_11 = {
  key: 0,
  class: "navbar-item"
}
const _hoisted_12 = { class: "field is-grouped" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  key: 1,
  class: "navbar-item"
}
const _hoisted_15 = { class: "field is-grouped" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = {
  key: 2,
  class: "navbar-item"
}
const _hoisted_18 = { class: "field is-grouped" }
const _hoisted_19 = { class: "control" }
const _hoisted_20 = {
  key: 3,
  class: "navbar-item"
}
const _hoisted_21 = { class: "field is-grouped" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = {
  key: 4,
  class: "navbar-item"
}
const _hoisted_24 = { class: "field is-grouped" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = {
  key: 5,
  class: "navbar-item"
}
const _hoisted_27 = { class: "field is-grouped" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = {
  key: 6,
  class: "navbar-item"
}
const _hoisted_30 = { class: "field is-grouped" }
const _hoisted_31 = { class: "control" }
const _hoisted_32 = {
  key: 7,
  class: "navbar-item"
}
const _hoisted_33 = { class: "field is-grouped" }
const _hoisted_34 = { class: "control" }
const _hoisted_35 = {
  key: 8,
  class: "navbar-item"
}
const _hoisted_36 = { class: "field is-grouped" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = {
  key: 9,
  class: "navbar-item"
}
const _hoisted_39 = { class: "field is-grouped" }
const _hoisted_40 = { class: "control" }
const _hoisted_41 = {
  key: 10,
  class: "navbar-item"
}
const _hoisted_42 = { class: "field is-grouped" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = { class: "navbar-item" }
const _hoisted_45 = { class: "field is-grouped" }
const _hoisted_46 = { class: "control" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.636 5.636a9 9 0 1012.728 0M12 3v9"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.iconPath,
          alt: "Wise Vet Live",
          height: "100%"
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.getAccessType != 'newCustomer')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.landingScreen,
            class: "navbar-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Navbar.Start')), 1)
              ])
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_ctx.getAccessType != 'newCustomer')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'vets' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchManagementMode('vets'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Veterinarians')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'managers' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, [
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchManagementMode('managers'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Managers')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'customers' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", _hoisted_19, [
                      _createElementVNode("a", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchManagementMode('customers'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Customers')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'appointments' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, [
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchManagementMode('appointments'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Appointments')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'manager' && _ctx.getMngMode != 'products' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", _hoisted_25, [
                      _createElementVNode("a", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchManagementMode('products'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Products')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'availabilityconfig' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && _ctx.getHasAssociatedCalendar && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, [
                      _createElementVNode("a", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchVetMode('availabilityconfig'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.AvailConfig')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'availabilityslots' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && _ctx.getHasAssociatedCalendar && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, [
                      _createElementVNode("a", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.switchVetMode('availabilityslots'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.AvailSlots')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'customers' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("p", _hoisted_34, [
                      _createElementVNode("a", {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.switchVetMode('customers'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Customers')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getAccessType == 'vet' && _ctx.getVetMode != 'appointments' && !_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", _hoisted_37, [
                      _createElementVNode("a", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.switchVetMode('appointments'))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.Appointments')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.getShowingUserData && !_ctx.getCustDetailing && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("p", _hoisted_40, [
                      _createElementVNode("a", {
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showUserdata && _ctx.showUserdata(...args))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('Navbar.MyData')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getShowingUserData && !_ctx.getShowingPetRecord && !_ctx.getCustDetailing && !_ctx.getEditingCustomer && !(_ctx.getAccessType == 'vet' && !_ctx.getHasAssociatedCalendar) && !_ctx.getShowingAppointmentData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("p", _hoisted_43, [
                      _createElementVNode("a", {
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.endShowData && _ctx.endShowData(...args))),
                        class: "button is-primary"
                      }, _toDisplayString(_ctx.$t('General.Back')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("p", _hoisted_46, [
                  _createElementVNode("a", {
                    class: "button is-danger is-outlined",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.doLogout && _ctx.doLogout(...args)))
                  }, [
                    _hoisted_47,
                    _createTextVNode("   "),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Navbar.Logout')), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}